import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getVideoBySearch(title,merchantsName,videoClassify,pageNum,pageSize) {
  return request({
    url: '/video/getVideoList',
    params: {
      title: title,
      merchantsName: merchantsName,
      videoClassify: videoClassify,
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByVideoId(videoId) {
  return requestMsg({
    url: '/video/delByVideoId',
    params: {
      videoId: videoId,
    }
  })
}

export function getVideoById(videoId) {
  return requestMsg({
    url: '/video/getVideoById',
    params: {
      videoId: videoId,
    }
  })
}

export function updateVideo(video) {
  return requestMsg({
    method:"POST",
    url: '/video/updateVideo',
    data: JSON.stringify(video),
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
